const APP_PATH = 'app';
// const API_URL = "http://hva-app.harrys:8000/api";
const API_URL = "https://admin.hva.gr/api";


const APP_VERSION = '1.0.2';

const USER_ROLE = {
    USER: 0,
    ADMIN: 1,
}

const USER_ROLES = [
    'Χρήστης',
    'Διαχειριστής',
];

const PRODUCT_TYPE = {
    PRODUCT: 0,
    SERVICE: 1,
}

const ORDER_STATUS = {
    ON_PAYMENT: 0,
    NEW: 1,
    ON_PROGRESS: 2,
    SENT: 3,
    COMPLETED: 4,
    RETURNED: 5,
    CANCELED: 6,
    FAILED: 7
}

const ORDER_STATUSES = [
    'προς πληρωμή',
    'νέα',
    'σε εξέλιξη',
    'απεσταλμένη',
    'ολοκληρώθηκε',
    'επιστράφηκε',
    'ακυρώθηκε',
    'απέτυχε'
]

const PAYMENT_METHOD = {
    CARD: 0,
    COD: 1,
    BANK: 2,
}

const SHIPPING_METHOD = {
    COURIER: 0,
    STORE: 1,
}

const PASSPORT_PRODUCT_ID = 1;

const PASSPORT_STATUS = {
    ASSIGNED: 0,
    RETURNED: 1,
    DESTROYED: 2,
    INUSE: 3,
    ASSIGN: -1,
    RETURN: -2,
    DESTROY: -3,
    CHECK: -10
}

export {
    APP_PATH,
    API_URL,
    APP_VERSION,
    USER_ROLE,
    USER_ROLES,
    PRODUCT_TYPE,
    ORDER_STATUS,
    ORDER_STATUSES,
    PAYMENT_METHOD,
    SHIPPING_METHOD,
    PASSPORT_PRODUCT_ID,
    PASSPORT_STATUS,
}